export default class CallApp {
  parent = null

  native_obj = null
  webkit = null

  constructor() {
    this.parent = parent
    if (window) {
      this.native_obj = window.nativeObj
      this.webkit = window.webkit
    }
  }

  postMessage({ action, params }) {
    return this?.webkit?.messageHandlers?.callApp?.postMessage(
      JSON.stringify({
        action,
        params
      })
    ) ?? false
  }

  navigateTo({ open_by, schema_url, link_url, config = null }) {
    return this.postMessage({
      action: 'open',
      params: {
        openBy: open_by,
        schemaUrl: schema_url,
        linkUrl: link_url,
        config
      }
    })
  }

  showShare({ title, description, icon, url }) {
    return this.postMessage({
      action: 'share',
      params: { title, description, icon, url }
    })
  }

  close() {
    return this.postMessage({ action: 'close' })
  }
}
